import React, { Dispatch, SetStateAction } from 'react';

import { SelectionName, SelectionPeriod, OUTPATIENT_TYPES } from 'pages/benefits/types/benefitTypes';
import { PolicyInfoResponse } from 'all-in-one-shared-api';

interface IBenefitContextValue {
  selectedFilterName: Partial<SelectionName>;
  selectedFilterPeriod: Partial<SelectionPeriod>;
  policyInfoData?: Array<PolicyInfoResponse>;
  selectedOutpatientTab: OUTPATIENT_TYPES;
  setSelectedOutpatientTab: Dispatch<SetStateAction<OUTPATIENT_TYPES>>;
}

const BenefitContextValue = {
  selectedFilterName: {},
  selectedFilterPeriod: {},
  policyInfoData: [],
  selectedOutpatientTab: OUTPATIENT_TYPES.COVERAGE,
  setSelectedOutpatientTab: () => undefined,
};

export default React.createContext<IBenefitContextValue>(BenefitContextValue);
